import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const faviconUrl = `/api/station-favicon?latest=${Date.now()}`;
document.title = 'Rock Planet Radio';
document.querySelectorAll<HTMLLinkElement>('link[data-station-favicon]').forEach((link) => {
  link.href = faviconUrl;
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
